/**
 * useTranslation Hook
 * Provides translation function and language management
 * Convenience hook that wraps useI18n context
 */

import { useI18n } from '../contexts/I18nContext';
import type { TranslationParams } from '../types/i18n';

interface UseTranslationReturn {
  t: (
    key: string,
    defaultValueOrParams?: string | TranslationParams,
    params?: TranslationParams
  ) => string;
  changeLanguage: (code: string) => Promise<void>;
  currentLanguage: string;
  isLoading: boolean;
  error: Error | null;
}

/**
 * Hook to access translation functionality
 * @returns Translation function and language state
 */
export const useTranslation = (): UseTranslationReturn => {
  const { t, changeLanguage, currentLanguage, isLoading, error } = useI18n();

  return {
    t,
    changeLanguage,
    currentLanguage,
    isLoading,
    error,
  };
};
